import React, { FC, useEffect } from 'react';
import { RouteComponentProps, Route, Switch } from 'react-router';
import { useLocation, useHistory } from 'react-router-dom';
import urlJoin from 'url-join';
import { useAuth0 } from 'Auth';

import { reattributePolicies } from 'Admin/authPolicies';

import { List, Confirmation, Success, StoreProvider, StateType } from './';

export const Router: FC<RouteComponentProps> = ({ match }) => {
  const history = useHistory();
  const { user } = useAuth0();
  const canReattributePolicies = reattributePolicies(user!.effectiveGrants);

  // optional location state to initialize our store provider
  const location = useLocation<{
    initialState?: StateType;
  }>();

  useEffect(() => {
    // strip out location after we initialized store
    if (location.state?.initialState) {
      history.replace({
        ...location,
        state: undefined,
      });
    }
  }, [location, history]);

  if (!canReattributePolicies) return null;

  return (
    <StoreProvider state={location.state?.initialState}>
      <Switch>
        <Route path={urlJoin(match.url, '/')} component={List} exact={true} />
        <Route
          path={urlJoin(match.url, '/confirm')}
          component={Confirmation}
          exact={true}
        />
        <Route
          path={urlJoin(match.url, '/success')}
          component={Success}
          exact={true}
        />
      </Switch>
    </StoreProvider>
  );
};
